import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Flex, Text } from "@radix-ui/themes";

// Only allow a same-origin path so `return_to` can't be used as an open
// redirect — must start with a single `/` and not be a protocol-relative `//…`.
const isSafeReturnTo = (value: string | null): value is string =>
  value !== null && value.startsWith("/") && !value.startsWith("//");

export default function StripeCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const success = searchParams.get("stripe_success");
    const payload = {
      type: "stripe-connect-complete",
      success: success === "true",
      error: searchParams.get("error") ?? undefined,
    };

    if (window.opener && window.opener !== window) {
      try {
        window.opener.postMessage(payload, window.location.origin);
      } catch {}
      window.close();
      return;
    }

    const returnTo = searchParams.get("return_to");
    if (isSafeReturnTo(returnTo)) {
      const sep = returnTo.includes("?") ? "&" : "?";
      window.location.replace(
        `${returnTo}${sep}stripe_success=${success ?? "false"}${
          payload.error ? `&error=${encodeURIComponent(payload.error)}` : ""
        }`,
      );
    }
  }, [searchParams]);

  return (
    <Flex align="center" justify="center" style={{ height: "100vh" }}>
      <Text size="2" color="gray">
        Finishing up — you can close this window.
      </Text>
    </Flex>
  );
}
